import type { IconPrimitives, IconProps } from './types';

export const buildArtifactIcons = ({ Svg, Path, Circle, Rect, Ellipse, defaultColor }: IconPrimitives) => ({
  // ArtifactIcons holds project artifact/review document glyphs such as scope and change-order icons.
  ScopeIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d='M7 10.5L8.5 9L10 10.5L8.5 12L7 10.5Z' stroke={color} strokeWidth='1.25' strokeLinejoin='round' />
      <Path d='M12 10.5L14 8.5L16 10.5L14 12.5L12 10.5Z' stroke={color} strokeWidth='1.25' strokeLinejoin='round' />
    </Svg>
  ),
  ChangeOrderIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d='M0.974973 20.8L22.975 20.8L11.975 3.79999L0.974973 20.8Z' stroke={color} strokeMiterlimit={10} strokeLinecap='round' strokeLinejoin='round' />
    </Svg>
  ),
  CloseOutIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d='M9.5 7.5H14.5L17 10V16.5H7V10L9.5 7.5Z' stroke={color} strokeWidth='1.25' strokeLinejoin='round' />
    </Svg>
  ),
  ScopeAddendumIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d='M12 7L17 12L12 17L7 12L12 7Z' stroke={color} strokeWidth='1.25' strokeLinejoin='round' />
      <Path d='M12 7L15 10L12 13L9 10L12 7Z' stroke={color} strokeWidth='1.25' strokeLinejoin='round' />
    </Svg>
  ),
});
